import { getIsOfferDisabled } from '@/utils/modules/rfp/professional/isOfferDisabled';
/**
 * コンサルタントが提案詳細/編集ページに遷移可能か判定する
 * @param args
 */
export const getIsOfferLinkDisabled = (args) => {
    const { hasOffer, ignoreCallEndDate, isCalling, isProposalTodo } = args;
    // 提案済みの場合はリンクを無効化しない
    if (hasOffer) {
        return false;
    }
    // 提案意向ありでない場合、リンクを無効化する
    if (!isProposalTodo) {
        return true;
    }
    // 編集可能な状態でない場合、リンクを無効化する
    return getIsOfferDisabled({ hasOffer, ignoreCallEndDate, isCalling });
};
